module.exports = __webpack_public_path__ + "static/img/2.bba9755.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/zh/2.png
// module id = xDZ4
// module chunks = 0